











import { Component, Vue } from 'vue-property-decorator';
import axios from 'axios';
import Toast from 'vue2-toast';
import {loadProgressBar} from 'axios-progress-bar';
import CommonUtils from './common-utils'
import Constants from './constants';
import { SettingsOmrVO } from '@/components/vo/Settings.vo'
import { SnackbarHideVO } from '@/components/vo/Snackbar.vo'
import { WrongAnswerNoteOVO, QuestionType } from '@/views/biz/note/vo/WrongAnswerNote.vo'
require('@/assets/js/rn-webview-bridge');
import mobileDeviceDetect from 'mobile-device-detect';
import 'axios-progress-bar/dist/nprogress.css'
import 'vue2-toast/lib/toast.css';

import { store } from '@/plugins/store'


Vue.use(Toast, {
    type: 'bottom',
    duration: 1500,
})

declare module 'vue/types/vue' {
    interface Vue {
      $toast(message: string): void;
    }
}

@Component
export default class App extends Vue {
  overlay = true;

  created(): void {

    const platform = this.isMobileReally ? '1': '3';

    axios.get(`/common/app-version/${platform}`).then((r) => {
      const version = r.data as string;

      if(platform == '1') {
        const userAgent = navigator.userAgent.toLowerCase();
        const appVersion = userAgent.substring(userAgent.lastIndexOf('version:') + 8);
        
        if(appVersion != version) {
          alert('새로운 버전이 출시됐어요. 업데이트를 받아주세요.');
          window["webViewBridge"].send("forceExit", { queryString: appVersion }, null);
          return;
        }
        return;
      }

      const localAppVersion = localStorage.getItem(Constants.APP_VERSION);
      if (!localAppVersion) {
        // 앱버전이 없으면
        localStorage.setItem(Constants.APP_VERSION, version); // 로컬 스토리지에 넣음
      } else if (localAppVersion != version) {
        localStorage.setItem(Constants.APP_VERSION, version); // 로컬 스토리지에 넣고
        window.location.reload(true); // 강력새로고침
      }

      
    });


    axios.interceptors.request.use(config=> {
      // loadProgressBar();
       !this.overlay && ( this.overlay = true)
      return config;
    });

    ///////////////////////////
    // 서버 공통 응답
    ///////////////////////////
    axios.interceptors.response.use(response=> {
      this.overlay = false;
      return response;
    }, error=> {
      this.overlay = false;
      if(!error.response) {
        // 서버 응답이 지연...
        this.$toast('서버 응답이 지연되고 있어요');
        return Promise.reject(error);
      }

      // 서버 Exception Handler와 연계
      let params;
      switch(error.response.status){
        case 401:
          if('UsernameNotFoundException' == error.response.data.exceptionName) {
            break;
          }
          // 세션 종료 처리
          this.$toast('로그인이 필요해요');
          this.$router.push({name: 'Login'})
          break;
        case 500:
          if(!error.response.data){
            break;
          }
          switch(error.response.data.exceptionName) {
            case 'BadCredentialsException':
              this.$toast('아이디 또는 비밀번호를 확인해주세요');
              break;              
            case 'AccessDeniedException':
              this.$toast('재로그인 해주세요');
              break;     
            case 'BussinessException':
              if(error.response.data.messageCode) {
                this.$toast(error.response.data.messageCode);
              } else {
                this.$toast('처리하는 도중 오류가 발생했어요');
              }
              break;          
            default:
              this.$toast('처리하는 도중 오류가 발생했어요');
              break;
          }
          break;
        default:
          break;
      }
      return Promise.reject(error);
    });

    Vue.filter('datetime', (val) => {
      return val.substring(2,10)
    });

    Vue.prototype.$windowSize = () => {
      switch (this.$vuetify.breakpoint.name) {
        case 'xs': return 220
        case 'sm': return 400
        case 'md': return 500
        case 'lg': return 600
        case 'xl': return 800
      }
    }


    Vue.prototype.$getQuestionType = (item: WrongAnswerNoteOVO) => {
      return CommonUtils.getQuestionType(item);
    }

    Vue.prototype.$isApp = (item: WrongAnswerNoteOVO) => {
      return CommonUtils.isApp();
    }
    
  }

  mounted(): void {
    const userSettings = CommonUtils.getLocalStorageObject(Constants.SETTINGS_OMR) as SettingsOmrVO;

    // 설정 기본값 세팅
    let settingsOmr = {} as SettingsOmrVO;
    settingsOmr.isAutoGrade = false;
    settingsOmr.isShowCorrectAnswer = true;
    settingsOmr.isExtendedOmr = false;
    settingsOmr.gradeQstCnt = 1;
    settingsOmr.correctAnswersPctg = 25;

    settingsOmr.isGroupQuestion = false;
    settingsOmr.isShowUnknownQuestion = true;
    settingsOmr.isShowAmbiguousQuestion = true;
    settingsOmr.isShowKnownQuestion = true;
    settingsOmr.isFullHideQuestion = false;

    settingsOmr.timerMinute = 35;
    settingsOmr.isTimer = false;
    settingsOmr.isAutoSwap = false;
    settingsOmr = Object.assign(settingsOmr, userSettings);


    CommonUtils.putLocalStorageObject(Constants.SETTINGS_OMR, settingsOmr);


    let snackbarHide = CommonUtils.getLocalStorageObject(Constants.SNACKBAR_HIDE) as SnackbarHideVO;
    // 스낵바 도움말 다시보지 않기 기본값
    if(!Object.keys(snackbarHide).length) { 
      snackbarHide = {} as SnackbarHideVO;
      snackbarHide.unknown = false;
      snackbarHide.hideGrading = false;

      CommonUtils.putLocalStorageObject(Constants.SNACKBAR_HIDE, snackbarHide);
    }

    window.addEventListener("rnBack", () => {
      if (this.isMobileReally) {
        // 메인화면에서 2번 누르면 앱 종료
        if (this.$route.name == "Main") {
          window["webViewBridge"].send("exitApp", { queryString: "" }, null);
          return;
        }
        this.$router.go(-1);
        // 모바일웹
      } else {
        this.$router.go(-1);
      }
    });

    this.overlay = false;
  }

  // getLastPopupComponent() {
  //   if(store.state.openedModals.length) {
  //     store.dispatch('popLastModal');
  //     return;
  //   }
  // }

  get isMobileReally() {
    const userAgent = navigator.userAgent.toLowerCase();
    return userAgent.indexOf('knou-omr-app') > -1;
  }
}
